import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShowImageDto } from '../../../../data/models/dto/arrival/authorized-responsable/show-image';
import { ImageType } from '../../../../data/models/enum/arrival/authorized-responsable/image-type.enum';

@Component({
  selector: 'app-close-image',
  templateUrl: './close-image.component.html',
  styleUrls: ['./close-image.component.scss'],
})
export class CloseImageComponent implements OnInit {
  imgPhoto: string | undefined;
  changePhotoMessage: string =
    'Ao pressionar a imagem você conseguirá trocar a visualização';
  closePicture = '';
  hideBox = '';
  responsableDialog = '';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ShowImageDto
  ) {
    this.imgPhoto = this.data.photo[0];
    this.closePicture =
      this.data.typePicture === ImageType.DOCUMENT
        ? 'show-document-container'
        : 'show-image-container';
    this.hideBox =
      this.data.typePicture === ImageType.PROFILE
        ? this.hideBox.concat(' close')
        : '';
  }

  ngOnInit(): void {}

  changeImage() {
    if (
      this.data.photo.length > 1 &&
      this.imgPhoto?.includes(this.data.photo[0])
    ) {
      this.imgPhoto = this.data.photo[1];
    } else {
      this.imgPhoto = this.data.photo[0];
    }
  }

  closeMessage() {
    this.hideBox = this.hideBox.concat(' close');
  }
}
